import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {
  administerMap,
  PrescriptionCardClass,
  PrescriptionTag,
  restrictionMap,
  FoodRestriction,
  prescriptionStatusMap,
  PrescriptionStatus,
} from '@drl/shared/utility/patients-caregiver-utility.enum';
import * as moment from 'moment';

import {PrescriptionMedicines} from '../models';
import {Prescriptions} from '../models/prescription.model';
import {IpsTranslateService} from '@drl/core/localization/ips-translate.service';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class PrescriptionAdapter implements IAdapter<Prescriptions> {
  constructor(protected readonly translateSvc: IpsTranslateService) {
    this.translate = this.translateSvc.translate;
  }
  translate: TranslateService;
  adaptToModel(resp: any): Prescriptions {
    if (resp.duration) {
      resp.endDate = moment(resp.startDate).add(resp.duration, 'days').toDate();
    }
    if (resp.medicines && resp.medicines.length > 0) {
      resp.medicines.forEach(med => {
        if (med.time) {
          med.timeToTake = moment(med.time).format(moment.HTML5_FMT.TIME_SECONDS);
          delete med.time;
        }
        if (med.reminderTime) {
          const [hours, minutes, sec] = (med.reminderTime as string).split(':');
          const reminderDate = new Date();
          reminderDate.setHours(parseInt(hours, 0), parseInt(minutes) || 0, parseInt(sec) || 0); // Set the hours
          med.reminderTime = reminderDate;
        }
      });
    }
    if (moment() > moment(resp.endDate)) {
      resp.type = PrescriptionTag.OLD;
    }

    if (resp.medicines) {
      resp.medicines = this.updateMeds(resp.medicines);
    }
    if (moment() > moment(resp.endDate)) {
      resp.type = PrescriptionTag.OLD;
      resp.style = PrescriptionCardClass.OLD;
    } else if (resp.isActive === true) {
      resp.type = PrescriptionTag.ACTIVE;
      resp.style = PrescriptionCardClass.ACTIVE;
    } else {
      resp.type = PrescriptionTag.NEW;
      resp.style = PrescriptionCardClass.NEW;
    }
    if(resp.status !== PrescriptionStatus.Active){
      resp.isPrescriptionDone = true;
    }
    if(resp.status === PrescriptionStatus.Stopped){
      resp.isPrescriptionStopped = true;
    }
    if(resp.status) {
      resp.status = prescriptionStatusMap(this.translate)[
        parseInt(resp.status)
      ];
    }
    if(resp.medicines && resp.medicines.length > 0) {
      resp.medicines.forEach((med: PrescriptionMedicines) => {
        const timeStr = med.reminderTime;
        // Create a Date object using today's date and the time string
        const date = new Date(`1970-01-01T${timeStr}Z`);
        // Format to 12-hour clock with lowercase am/pm
        med.reminderTimeString = date.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true
        }).toLowerCase();
      });
    }
    resp.prescriptionFiles = resp.prescriptionFiles || [];
    return resp;
  }
  adaptFromModel(data: Prescriptions): any {
    if (data.endDate) {
      delete data.endDate;
    }
    if (data.medicines && data.medicines.length > 0) {
      data.medicines.forEach(med => {
        if(med.time) {
        med.timeToTake = moment(med.time).format(moment.HTML5_FMT.TIME_SECONDS);
        delete med.time;
        }
      });
    }
    if(data?.prescriptionFiles){
      delete data.prescriptionFiles;
    }
    delete data.type;
    delete data.style;
    delete data.stopReasonLc;
    return data;
  }

  private updateMeds(meds: PrescriptionMedicines[]) {
    return meds.map((med: PrescriptionMedicines) => {
      if (
        med.locationOfAdministration ===
        administerMap(this.translate).AtHospital.value
      ) {
        med.location = administerMap(
          this.translateSvc.translate,
        ).AtHospital.label;
      } else if (
        med.locationOfAdministration ===
        administerMap(this.translateSvc.translate).AtHome.value
      ) {
        med.location = administerMap(this.translateSvc.translate).AtHome.label;
      } else {
        med.location = 'Other';
      }
      if (
        med.foodRestriction &&
        restrictionMap(this.translateSvc.translate)[med.foodRestriction]
      ) {
        med.foodRestrictionLabel = restrictionMap(this.translateSvc.translate)[
          med.foodRestriction
        ].label;
        med.restrictionImg = restrictionMap(this.translateSvc.translate)[
          med.foodRestriction
        ].img;
      } else {
        med.foodRestrictionLabel = restrictionMap(this.translateSvc.translate)[
          FoodRestriction.NoRestrictons
        ].label;
        med.restrictionImg = restrictionMap(this.translateSvc.translate)[
          FoodRestriction.NoRestrictons
        ].img;
      }
      return med;
    });
  }
}
